// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import promise from 'es6-promise'
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'

// import kyChat from '../packages/chat/index'
import kyChat from '../src/index'

Vue.config.productionTip = false

promise.polyfill()

Vue.use(ElementUI)
Vue.use(Vuex)
Vue.use(kyChat)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./examples/main.js